import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material/material.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { UploadPrescriptionPopupModule } from '../upload-prescription-popup/upload-prescription-popup.module';
import { CartSlideComponent } from './cart-slide/cart-slide.component';
import { HeaderComponent } from './header.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import {RequestMedicineModule} from "../../dialog-view/request-medicine/request-medicine.module";



@NgModule({
  declarations: [
    HeaderComponent,
    SideNavComponent,
    CartSlideComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    FormsModule,
    SharedModule,
    UploadPrescriptionPopupModule,
    MaterialModule,
    RequestMedicineModule
  ],
  exports: [
    HeaderComponent
  ]
})
export class HeaderModule { }
